import { IdentifiableDto } from "./identifiable.dto";
import { HiringStateDto } from "./lookup.dto";

export class HiringCityDto extends IdentifiableDto {
    name!: string;
    lat!: number;
    lng!: number;
    state: HiringStateDto;
}